import type { BuilderType } from '@shared/utils/api/configs/rtkBaseQueryDemo';
import { GET_PUBLIC_RECAPTCHA } from '@shared/utils/api/configs/URL';
import { hasCcdpPartialSuccess, hasCcdpSuccess } from '@shared/utils/api/handlers/interpretCcdpCode/interpretCcdpCode';
import type { GenericApiResponse } from '@shared/utils/api/types';

import type { GetCaptchaRequestPayload, IGetPublicCaptchaResult } from '../types/getCaptcha.types';

const PAYMENT_RECHAPTCH = 'ReCaptcha';

export const getReCaptcha = (builder: BuilderType) =>
  builder.query<boolean, GetCaptchaRequestPayload>({
    providesTags: [PAYMENT_RECHAPTCH],
    query: (data) => ({
      data,
      method: 'POST',
      url: GET_PUBLIC_RECAPTCHA,
    }),
    transformResponse: (response: GenericApiResponse<IGetPublicCaptchaResult>) => {
      if (hasCcdpSuccess(response) || hasCcdpPartialSuccess(response)) {
        return response.Result.IsValidCaptcha;
      }
      throw {
        code: response.Code,
        message: response.Message,
      };
    },
  });
